import { call, put, select, takeLatest } from 'redux-saga/effects';

import authService from 'services/authService';

import { fetchProfile } from 'store/session/actions';
import { getUser } from 'store/session/selectors';

import { types, userInfo, userInfoUpdate } from './actions';

export default function* root() {
  yield takeLatest(types.USER_INFO_UPDATE_REQUEST, watchUserProfileUpdate);
}

function* watchUserProfileUpdate(action) {
  try {
    const { firstName, lastName } = action.payload;
    const username = (yield select(getUser)).username;
    yield call(authService.updateUser, username, {
      firstName,
      lastName,
    });
    yield put(fetchProfile.request());
    yield put(userInfoUpdate.success());
  } catch (error) {
    yield put(userInfoUpdate.error(error));
  }
}

export function* initSaga() {
  yield put(userInfo.init());
}
